import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    POLL_SHARE_MODE, POLL_TYPE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import classes from "../CreateQuizPage/ActivityEditor.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as SAVED_SUCCESSFULLY} from "../../images/activity_saved_successfuly_image.svg";
import React, {useState} from "react";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {deCapitalizeWord, notifyError} from "../../utils/helpers";


export default function PPTActivitySaved({pollKey, pollCode, savedActivity}) {
    const { t } = useTranslation();

    const { goPollsPage, goPollsPageDirectly} = usePPTWebView();
    const {checkAppRunning, takeScreenshotsNew} = ReportApiCalls();
    const {updatePollDetails} = PollApiCalls();
    const {embedActivity, isLMSAuthorized} = LTIApiCalls();
    const {needsLMSEmbedding} = useSynLMSConfiguration();

    const [isProcessing, setIsProcessing] = useState(false);

    const onClickViewAll = () => {
        goPollsPageDirectly(savedActivity.pollType);
    }

    const onClickInsert = async () => {
        const {pollType, pollShareMode, syncLms, syncLmsOption="", lmsHomeUrl="", LMSColumnId, questions=[]} = savedActivity;
        if (pollType === POLL_TYPE.ATTENDANCE) {
            try {
                const pollDetails = {};
                setIsProcessing(true);
                pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_EACH;
                const shouldEmbed = needsLMSEmbedding(savedActivity);
                if (shouldEmbed) {
                    let authorized = await isLMSAuthorized();
                    if (!authorized) {
                        setIsProcessing(false);
                        return;
                    }
                }
                await updatePollDetails(pollKey, pollCode, pollDetails, true);

                if (shouldEmbed) {
                    let isSuccess = await embedActivity(pollKey, pollCode);
                    if (isSuccess) {
                        // the new slides carry the LMS QR code, so wait for them before the app starts inserting
                        await takeScreenshotsNew(pollKey, pollCode, false, []);
                    }
                }

                checkAppRunning(pollKey, pollCode, POLL_SHARE_MODE.SHARE_EACH, pollType, 1).catch(err => {
                    console.log(err);
                    notifyError(t("report.insertSlideError", {
                        activityType: pollType === POLL_TYPE.ATTENDANCE ? t("poll.attendanceLabel") : t("poll.mergedModeText")
                    }));
                    setIsProcessing(false);
                });
                // goInsertWaitingPage(pollType);
            } catch (err) {
                console.log(err);
                setIsProcessing(false);
            }
        } else {
            goPollsPage({pollKey, pollCode, pollType, pollShareMode, syncLms, syncLmsOption, lmsHomeUrl, LMSColumnId, totalQuestions: questions.length});
        }
    }

    return (
        <div
            className={`${classes.parentContainer} ${classes.straightColumnLayout}`}
            style={{alignItems: "center", gap: 20, padding: 20}}
        >
            <span style={{flex: 1}}/>
            <SAVED_SUCCESSFULLY style={{marginBottom: 20}}/>
            <span className={classes.title} style={{fontSize: 20}}>
                {t("questionBuilder.savedActivityText", {
                    activityType: savedActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? t("poll.attendanceLabel")
                        : t("poll.mergedModeText")
                })}
            </span>
            <span className={classes.description}>
                {t("questionBuilder.pptSavedActivityDescription", {
                    activityType: savedActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? deCapitalizeWord(t("poll.attendanceLabel"))
                        : deCapitalizeWord(t("poll.mergedModeText"))
                })}
            </span>
            <div style={{display: "flex", marginTop: 20, gap: 10}}>
                <YuJaButton
                    type={"secondary"}
                    style={{width: 180, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whitespace: "nowrap"}}
                    onClick={onClickViewAll}
                >
                    {
                        t("questionBuilder.viewAllActivitiesPlaceholderText", {
                            activityTypes: (savedActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? t("poll.attendanceLabel")
                                : t("poll.mergedModeText")) + "s"
                        })
                    }
                </YuJaButton>

                <YuJaButton
                    disabled={isProcessing}
                    style={{minWidth: 180, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whitespace: "nowrap"}}
                    onClick={onClickInsert}
                >
                    {
                        t("poll.insertActivityText", {
                            activityType: savedActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? t("poll.attendanceLabel")
                                : t("poll.mergedModeText")
                        })
                    }
                </YuJaButton>

            </div>
            <span style={{flex: 1}}/>
        </div>
    );
}